import { selectDisplayProductsMode } from '@/data/replenishmentPlan/slice/replenishmentPlan.selectors.ts'
import { DisplayProductsMode } from '@/data/replenishmentPlan/slice/replenishmentPlan.types.ts'
import { replenishmentPlanActions } from '@/data/replenishmentPlan/slice/replenishmentPlan.slice.ts'
import { useTranslation } from 'react-i18next'
import { useEffect, useMemo } from 'react'
import { CustomToggleButtonGroup } from '@/ui/components/CustomToggleButtonGroup'
import { useDispatch, useSelector } from 'react-redux'
import { useTrackReplenishmentPlanAnalyticsEvent } from '@/core/hooks/useTrackReplenishmentPlanAnalyticsEvent.ts'
import { DatagridViewEvent } from '@/core/analytics/events/replenishmentPlan/DatagridViewEvent.ts'

const DisplayProductsModeToggle = () => {
  const { trackReplenishmentPlanAnalyticsEvent } =
    useTrackReplenishmentPlanAnalyticsEvent()

  const displayProductsMode = useSelector(selectDisplayProductsMode)

  const dispatch = useDispatch()

  useEffect(() => {
    trackReplenishmentPlanAnalyticsEvent(
      new DatagridViewEvent({
        mode:
          displayProductsMode === DisplayProductsMode.categories
            ? 'categories'
            : 'plain',
      }),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackReplenishmentPlanAnalyticsEvent])

  const onChange = (displayProductsMode: DisplayProductsMode) => {
    trackReplenishmentPlanAnalyticsEvent(
      new DatagridViewEvent({
        mode:
          displayProductsMode === DisplayProductsMode.categories
            ? 'categories'
            : 'plain',
      }),
    )

    dispatch(
      replenishmentPlanActions.setDisplayProductsMode(displayProductsMode),
    )
  }

  const { t } = useTranslation()

  const displayProductsModeToText: Record<DisplayProductsMode, string> =
    useMemo(
      () => ({
        [DisplayProductsMode.categories]: t(
          'displayProductsModeToggle.categories',
        ),
        [DisplayProductsMode.plainList]: t(
          'displayProductsModeToggle.plainList',
        ),
      }),
      [t],
    )

  const displayProductsModeToTooltip: Record<DisplayProductsMode, string> =
    useMemo(
      () => ({
        [DisplayProductsMode.categories]: t(
          'displayProductsModeToggle.categoriesTooltip',
        ),
        [DisplayProductsMode.plainList]: t(
          'displayProductsModeToggle.plainListTooltip',
        ),
      }),
      [t],
    )

  return (
    <CustomToggleButtonGroup
      optionToString={(option) => displayProductsModeToText[option]}
      options={[DisplayProductsMode.categories, DisplayProductsMode.plainList]}
      value={displayProductsMode}
      getTooltipText={(option) => displayProductsModeToTooltip[option]}
      onChange={onChange}
    />
  )
}

export default DisplayProductsModeToggle
